module.exports = __webpack_public_path__ + "static/media/4bVideo.b5242a39.mp4";